import { connect } from 'react-redux';
import { startRequest as startRequestLoadingContactInfo } from '../../Profile/redux/contactInfo/actions';
import { startRequest as startRequestLoadingPersonalData } from '../../Profile/redux/personalData/actions';
import PersonalInfoGP3 from '../components/PersonalInfoGP3/index';
import { startRequest as startRequestLoadingDocumentTypes } from '../redux/documentTypes/actions';
import { startRequest as startRequestFiasAddress } from '../redux/fiasAdress/actions';
import { getInfo } from 'modules/App/redux/user/actions';

@connect(function ({
  taps: { documentTypes, fiasAddress },
  profile: { personalData, contactInfo },
  app: { user },
  form,
}) {
  return {
    personalInfo: personalData,
    user,
    documentTypes,
    contactInfo,
    form,
    fiasAddress,
  };
})
export default class PersonalInfoGP3Container extends PersonalInfoGP3 {
  loadPersonalData() {
    this.props.dispatch(startRequestLoadingPersonalData());
  }

  loadDocumentTypes() {
    this.props.dispatch(startRequestLoadingDocumentTypes());
  }

  loadContactInfo() {
    this.props.dispatch(startRequestLoadingContactInfo());
  }

  loadFiasAddress() {
    this.props.dispatch(startRequestFiasAddress());
  }
  loadUserInfo() {
    this.props.dispatch(getInfo());
  }
}
